import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

import { getToken } from 'user-auth'

const deleteMapById = async (mapId) => {
  const token = await getToken()
  if (!token) throw new Error('Invalid token')
  await API.graphql({
    query: DELETE_MAP_BY_ID_MUTATION,
    variables: {
      id: mapId
    },
    authMode: 'AMAZON_COGNITO_USER_POOLS',
    authToken: token
  })
}

const DELETE_MAP_BY_ID_MUTATION = gql`
  mutation DeleteMapById($id: ID!) {
    deleteMapById(id: $id) {
      id
    }
  }
`

export { DELETE_MAP_BY_ID_MUTATION, deleteMapById }
export default deleteMapById
